<template>
  <el-container>
    <Header :key="key" :prefix="preFix" />
    <router-view @childPrefix="getValFromChild" />
    <BackTop :height="100" :bottom="600">
      <div class="top">
        <img
          class="desktopImg"
          src="/images/anniversary2023/other/gotop_透明度.svg"
          :id="gotopId"
        />
        <img
          class="mobileImg"
          src="/images/anniversary2023/other/gotop_mobile.svg"
          :id="gotopId"
        />
      </div>
    </BackTop>
    <Footer :key="key" :prefix="preFix" />
    <!-- <Footer :key="key" :prefix="preFix" v-show="showFooter" /> -->
  </el-container>
</template>

<script lang="ts">
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { ref, watch, Ref, defineComponent, onMounted } from "vue";
import { useScroll, useDebounceFn } from "@vueuse/core";
import DeviceServices from "@/services/DeviceServices";
import { useHead } from "@vueuse/head";
import BGOServices from '@/services/BGOServices';
import BGOTrackingServices from '@/services/BGOTrackingServices';

export default defineComponent({
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      preFix: "",
      gotopId: this.prefix + "gotop",
      key: 1,
      showFooter: true,
    };
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
    const jump = this.$route.query.q;
    if (jump) {
      if (typeof jump === "string") {
        const element = document.getElementById(jump);
        console.log(jump);
        if (element) {
          console.log("jump");
          element.scrollIntoView();
        }
      }
    }
  },
  methods: {
    getValFromChild(val) {
      console.log(val);
      this.preFix = val;
      this.key += 1;
    },
    handleScroll() {
      // const footer = document.getElementById('footer');
      // const scrollPosition = window.innerHeight + window.pageYOffset;
      // const bodyHeight = document.body.offsetHeight;
      // if (scrollPosition >= bodyHeight) {
      //   this.showFooter = true;
      // } else {
      //   this.showFooter = false;
      // }
    },
  },
  setup() {
    // 滑動隱藏footer -- start
    // const isHidden = ref(true);
    // const { directions, isScrolling, arrivedState } = useScroll(document);
    // const checkHeaderStatus = useDebounceFn((top, bottom, topArrived) => {
    //   if (topArrived) {
    //     isHidden.value = false;
    //     return;
    //   }
    //   if (top) {
    //     isHidden.value = true;
    //   } else if (bottom) {
    //     isHidden.value = false;
    //     // handleScroll();
    //   }
    // }, 100);

    // const handleScroll = () => {
    //   console.log(1231231);
    //   const scrollContainer = document.documentElement;
    //   const atBottom =
    //     scrollContainer.scrollHeight - scrollContainer.scrollTop ===
    //     scrollContainer.clientHeight;
    //   console.log(
    //     "atBottom:" + atBottom,
    //     scrollContainer.scrollHeight,
    //     scrollContainer.scrollTop,
    //     scrollContainer.clientHeight
    //   );
    //   if (scrollContainer.scrollTop > 2000) {
    //     console.log("顯示底部區塊");
    //     isHidden.value = true;
    //   } else {
    //     isHidden.value = false;
    //   }
    // };
    // watch(directions, () => {
    //   if (isScrolling.value) {
    //     checkHeaderStatus(directions.top, directions.bottom, arrivedState.top);
    //   }
    // });
    // 滑動隱藏footer -- end
    let preFix = "";
    const isLoaded = ref(false);
    const isApp = ref(false);

    onMounted(async () => {
      // 載入 SDK
      console.time('載入 SDK');
      await Promise.all([BGOServices.loadSdk(), BGOTrackingServices.loadSdk()]);
      console.timeEnd('載入 SDK');

      // 載入 BGO
      // await BGOServices.loadSdk();
      // 檢查是否在 APP 中
      isApp.value = BGOServices.getIsApp();

      // 初始化 BGO
      BGOServices.init(
        import.meta.env.VITE_BGO_OFFICIAL_ACCOUNT_ID,
        import.meta.env.VITE_BGO_TOKEN,
      );
      
      console.log("是否在APP內開啟網頁:" + isApp.value);
      const head = useHead({
        meta: [
          {
            property: "open-default-browser",
            content: true,
          },
        ],
      });
      if (isApp.value) {
        // alert("注意!目前在APP內開啟活動頁!");
        let url = window.location.href;
        BGOServices.leaveExtension();
        BGOServices.openDefaultBrowser(url);
      }
    });

    return {
      preFix,
      //isHidden,
    };
  },
});
</script>
<style>
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);
body {
  overflow-x: hidden;
  /* overflow-y: hidden; */

  /*如果螢幕寬度為 375px 以下 ，就套用 css 設定 -- 
      iPhone SE, Samsung Galaxy S8+(360), Galaxy Fold(280)
  */
  @media screen and (max-width: 375px) {
  }
  /*如果螢幕寬度為 375px 以上 且 414px 以下，就套用 css 設定 - 
      iPhone XR, iPhone 12 Pro(390), Pixel 5(393), Samsung Galaxy S20 Ultra(412), Samsung Galaxy A51/71(412)
  */
  @media screen and (min-width: 376px) and (max-width: 414px) {
  }
  /*如果螢幕寬度為 415px 以上 且 1280px 以下，就套用 css 設定 - 
    Surface Duo(540)
  */
  @media screen and (min-width: 415px) and (max-width: 1031px) {
  }
  /*如果螢幕寬度為 1032px 以上 且 1280px 以下，就套用 css 設定 - 
    iPad Air(820), iPad Mini(768), Surface Pro 7(912), Nest Hub(1024)
  */
  @media screen and (min-width: 1032px) and (max-width: 1280px) {
  }
  /*如果螢幕寬度為 1281px 以上 ，就套用 css 設定 - 
    Nest Hub Max(1280), 桌面
  */
  @media screen and (min-width: 1281px) {
  }

  /* 先套用 Noto Sans TC 這個 思源黑體 */
  font-family: "Noto Sans TC", "微軟正黑體", sans-serif, "Helvetica Neue",
    Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑",
    Arial !important;
}
</style>
<style scoped>
.el-container {
  max-width: 99.9vw;
  overflow-x: hidden;
  display: block !important;
}
.desktopImg {
  
  display: none;
  /*如果螢幕寬度為 1032px 以上，就套用 css 設定 
  */
  @media screen and (min-width: 1032px) {
    display: block;
  }
}
.mobileImg {
  /*如果螢幕寬度為 1032px 以上，就套用 css 設定 
  */
  @media screen and (min-width: 1032px) {
    display: none;
  }
}
.ivu-back-top.ivu-back-top-show {
  right: 12px !important;
}
.top {
  position: fixed;
  bottom: 16px;
  right: 12px;
  /*如果螢幕寬度為 1031px 以下，就套用 css 設定*/
  @media screen and (max-width: 1031px) {
    position: fixed !important;
    bottom: 16px !important;
    right: 12px !important;
  }
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    position: fixed !important;
    top: 80% !important;
    right: 12px !important;
  }
}
</style>
